<template>
    <span
        class="flex items-center justify-center rounded-full w-10 h-10 border-4 border-white text-xs text-white"
        :class="member.color.length === '' ? 'bg-gray-300' : 'bg-'+member.color"
    >{{ getInicials(member) }} <md-tooltip md-direction="bottom">{{ member.name }}</md-tooltip></span>
</template>

<script>
    import {getInicials} from "../utils";

    export default {
        name: "Avatar",
        props: {
            member: {
                type: Object,
                required: true
            }
        },
        methods: {
            getInicials(m) {
                return getInicials(m.name, m.image);
            }
        }
    }
</script>

<style scoped>

</style>